(function() { window.GUID_48a2964b_9eef_4dbd_9897_efccfe71954c = { getGuid: function() { return "48a2964b-9eef-4dbd-9897-efccfe71954c"; } }; })();
function isFacebookSdkAllowed() {
    var _a;
    const bootstrap = (_a = window.CS) === null || _a === void 0 ? void 0 : _a.CookieConsentBootstrap;
    return (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.isAnalyticsMetaAccepted) === true;
}
function ensureFacebookSdkLoaded() {
    if (!isFacebookSdkAllowed()) {
        return;
    }
    const id = 'facebook-jssdk';
    if (document.getElementById(id)) {
        return;
    }
    const fjs = document.getElementsByTagName('script')[0];
    const js = document.createElement('script');
    js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}
window.fbAsyncInit = function () {
    if (!isFacebookSdkAllowed()) {
        return;
    }
    if (typeof (FB) !== 'undefined') {
        FB.init({
            appId: CS.GlobalConst.FacebookAppKey,
            autoLogAppEvents: true,
            xfbml: false,
            version: CS.GlobalConst.FacebookGraphApiVersion || 'v23.0',
        });
        $('html body').trigger('facebookinitialized');
        console.debug('facebook initialized');
    }
};
ensureFacebookSdkLoaded();
var Facebook;
(function (Facebook) {
    function EnsureSdkLoaded() {
        ensureFacebookSdkLoaded();
    }
    Facebook.EnsureSdkLoaded = EnsureSdkLoaded;
    function Share(urlToShare) {
        if (!isFacebookSdkAllowed()) {
            return;
        }
        ensureFacebookSdkLoaded();
        let data = {
            url: urlToShare,
        };
        CS.Ajax.Post("/Facebook/FetchFacebookUrl", data, function (response) {
            setTimeout(function () {
                if (typeof (FB) !== 'undefined') {
                    FB.ui({
                        method: 'share',
                        href: data.url,
                    }, function (response) { });
                }
                ;
            }, 500);
        });
    }
    Facebook.Share = Share;
    // export function Share() {
    //    FB.api('https://graph.facebook.com/', 'post', {
    //        id: 'https://compusport.ca/Sharefacebook1.html',
    //        access_token: '1094699144002890|O7WxCbOMP_JiCKQBq1VNixF40fI',
    //        scrape: true
    //    }, function (response) {
    //        setTimeout(function () {
    //            FB.ui({
    //                method: 'share',
    //                href: 'https://compusport.ca/Sharefacebook1.html'
    //            }, function (response) { });
    //        }, 1000);
    //    });
    // }
})(Facebook || (Facebook = {}));

//# sourceMappingURL=facebook.js.map
